import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY

if (!supabaseUrl || !supabasePublishableKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file has:\n' +
    '- VITE_SUPABASE_URL\n' +
    '- VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY'
  )
}

export const supabase = createClient(supabaseUrl, supabasePublishableKey)

export type SubscriptionTier = 'free' | 'trial' | 'pro'

export interface SubscriptionStatus {
  tier: SubscriptionTier
  trialDaysLeft?: number
  trialEndsAt?: string
  trialExpired?: boolean
}